import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import Button from "components/Forms/CustomButtons/ButtonTS";
import React from "react";
import { useTranslation } from "react-i18next";

interface ConfirmDeleteModalProps {
  modalOpen: boolean;
  fileName: string;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ConfirmDeleteModal({
  modalOpen,
  onClose,
  onConfirm,
  fileName,
  isDeleting,
}: ConfirmDeleteModalProps): JSX.Element {
  const { t } = useTranslation("modals");

  return (
    <Dialog
      open={modalOpen}
      fullWidth
      maxWidth="sm"
      scroll="body"
      onClose={() => {
        onClose();
      }}
      disableBackdropClick
    >
      <DialogTitle>
        {t("delete-file")}
        <Button
          justIcon
          simple
          color="tumblr"
          round
          size="sm"
          style={{
            position: "absolute",
            right: "10px",
            top: "10px",
          }}
          onClick={onClose}
        >
          <Close />
        </Button>
      </DialogTitle>

      <DialogContent>{fileName ?? "Something went wrong"}</DialogContent>

      <DialogActions>
        <Button disabled={isDeleting} color="tumblr" simple onClick={onClose}>
          {t("cancel")}
        </Button>

        <Button disabled={isDeleting} color="danger" onClick={onConfirm}>
          {t("delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
